// extracted by mini-css-extract-plugin
export default {"diffEntryHeader":"AutomatedReviewDiffEntry-module__diffEntryHeader__jpwSXXd","automatedReviewDiff":"AutomatedReviewDiffEntry-module__automatedReviewDiff__obcQSFa"};